import React, {memo, useCallback} from 'react';

import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate} from 'react-router-dom';

import {AppButton, AppButtonVariant} from '@/app/shared-components';

import {getEditInfoImage, redirectToEditInfoApp} from './constants';
import EditInfoLayout from './EditInfoLayout';
import {useEditInfoTrackers} from './useEditInfoTrackers';

function EditInfoRejectContent() {
  const {t} = useTranslation();
  const location = useLocation();
  const teenName: string = location.state?.teenName ?? '';
  const isMoGold: boolean = location.state?.isMoGold ?? false;
  const parentId: string = location.state?.parentId ?? '';

  const {trackSelectEditInfoResetPassword, trackSelectEditInfoBackToApp} =
    useEditInfoTrackers({
      parentId,
    });
  const navigate = useNavigate();

  const title = teenName
    ? t('edit_info.reject.title', {name: teenName})
    : t('edit_info.reject.title_generic');

  const handleResetPassword = useCallback(() => {
    trackSelectEditInfoResetPassword();
    navigate('/authentication/password/forgot');
  }, [navigate, trackSelectEditInfoResetPassword]);

  const handleGoBackToApp = useCallback(() => {
    trackSelectEditInfoBackToApp();
    redirectToEditInfoApp();
  }, [trackSelectEditInfoBackToApp]);

  return (
    <EditInfoLayout
      illustrationSrc={getEditInfoImage('moPhoneGlasses', isMoGold)}
      title={title}
      description={t('edit_info.reject.description')}
      buttons={
        <>
          <AppButton
            id="EditInfoReject_resetPasswordButton"
            sentry-label="EditInfoReject reset password button"
            label={t('edit_info.reject.primary_button')}
            onClick={handleResetPassword}
            variant={
              isMoGold
                ? AppButtonVariant.onPrimary
                : AppButtonVariant.onPrimaryGreen
            }
          />
          <AppButton
            id="EditInfoReject_goBackToAppButton"
            sentry-label="EditInfoReject go back to app button"
            label={t('edit_info.reject.secondary_button')}
            onClick={handleGoBackToApp}
            variant={
              isMoGold
                ? AppButtonVariant.onQuinary
                : AppButtonVariant.onTertiaryGreen
            }
          />
        </>
      }
    />
  );
}

const EditInfoRejectPage = memo(() => <EditInfoRejectContent />);

export default EditInfoRejectPage;
